import { render, staticRenderFns } from "./add-extend-amount.vue?vue&type=template&id=32c64842&"
import script from "./add-extend-amount.vue?vue&type=script&lang=js&"
export * from "./add-extend-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports